import axios from "axios";
import React, { useMemo } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { MaterialReactTable } from "material-react-table";
import { IoEyeSharp } from "react-icons/io5";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const EnquireTabel = () => {
  const { data,isLoading} = useQuery({
    queryKey: "getAllLead",
    queryFn: () =>
      axios.get(`${BASEURL}lead`).then((res) => {
        return res?.data;
      }),
  });
  const reversedData = data?.leads.sort((a, b) => b.id - a.id);
  const queryClient=useQueryClient()
  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}lead/${values?.id}`, values?.data);
    },
    onSuccess: ()=>{
      queryClient.invalidateQueries({ queryKey: "getAllLead" });
    },
  });

  const handleUpdate = (id) => {
    const values = {
      id: id,
      data: {
        status: false,
      },
    };

    editMutation.mutate(values);
  };

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        id: "index",
        header: "S.No",
      },
      {
        id: "name",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.name}
            </p>
          </>
        ),
        header: "Name",
      },
      {
        id: "email",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.email}
            </p>
          </>
        ),
        header: "Email",
      },
      {
        id: "phone",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.phone}
            </p>
          </>
        ),
        header: "Phone",
      },
      {
        id: "enquiry_message",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.enquiry_message}
            </p>
          </>
        ),
        header: "Message",
      },
      {
        id: "created_at",
        Cell: ({ row }) => (
          <>
            <p
              className={
                row.original.status === true ? "bold-row" : "normal-row"
              }
            >
              {row?.original?.created_at.slice(0, 10)}
            </p>
          </>
        ),
        header: "Enquire Date",
      },
      {
        id: "actions",
        header: "Status",
        Cell: ({ row }) => (
          <>
            {row?.original?.status ? (
              <div className="flex items-center justify-around text-speed-red font-semibold cursor-pointer">
                <p onClick={() => handleUpdate(row?.original?.id)}>UnRead</p>
              </div>
            ) : (
              <div className="flex items-center justify-around text-green-500 font-semibold">
                <p >Read</p>
              </div>
            )}
          </>
        ),
      },
    ],
    []
  );
  return (
    <div>
        {
        isLoading && <TraingleLoading />
      }
      <AdminTabelHeader title="Enquire Details" btnStatus={false} />
      <div className="p-4">
        <MaterialReactTable
          columns={columns}
          data={reversedData || []}
          enableColumnResizing
          enableColumnOrdering
          // enableGlobalFilter={false}
        />
      </div>
    </div>
  );
};

export default EnquireTabel;
